// extracted by mini-css-extract-plugin
export var scoreSetupContainer = "ScoreSetup-module--scoreSetupContainer--2qCPl";
export var scoreSetupTitle = "ScoreSetup-module--scoreSetupTitle--3WHsn";
export var scoreTargetInput = "ScoreSetup-module--scoreTargetInput--1D2uN";
export var scoreTargetSetupSubmitButton = "ScoreSetup-module--scoreTargetSetupSubmitButton--2gixC";
export var backButton = "ScoreSetup-module--backButton--2ErvW";